/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class TemplateExistsModal extends React.Component {
  render() {
    return (
      <div>
        <Modal isOpen={this.props.visible} toggle={this.props.toggle} className={this.props.className}>
          <ModalHeader toggle={this.props.toggle}>Template Already Exists</ModalHeader>
          <ModalBody>
            A template for this report, language and folder already exists - do you wish to create a new version of this template?
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.props.saveTemplate}>Yes</Button>{' '}
            <Button color="secondary" onClick={this.props.toggle}>Cancel</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default TemplateExistsModal;